import { showErrorMsg, showSuccessMsg } from "../utils/toast";
import api from "./api";
import { Logger } from "../utils/logger";
import { stringifyValues } from "../utils/tableFunctions";
import fileDownload from "js-file-download";
import { Log } from "./services";

// --------------- API Calls for Reports ----------------------- //

export async function getReportList(
  setList,
  setLoaded,
  download = false,
  filter = {}
) {
  filter = stringifyValues(filter);
  const url = "/report/admin/report/filter/";
  api
    .post(url, {
      ...filter,
      download: download ? "true" : "false",
    })
    .then((response) => {
      if (setList) {
        setList(response.data);
        setLoaded && setLoaded(true);
      }
      return response.data;
    });
}

export async function getReportCSV(filter) {
  const url = "/report/admin/report/filter/";
  filter = stringifyValues(filter);
  const data = await api.post(url, { download: "true", ...filter });
  return data.data;
}

// export function getReportList(setList, setLoaded, download = "false") {
//   const url = "/report/admin/report/filter/";
//   api
//     .post(url, {
//       download: download,
//     })
//     .then((response) => {
//       setList(response.data);
//       setLoaded(true);
//     });
// }

export function getReportFilterParam(setParams) {
  const url = "/report/admin/report/filter_conditions/";
  api.get(url).then((response) => {
    setParams(response.data);
  });
}

export function getReportDetails({
  id,
  setSummary,
  setProfile,
  setLoaded,
  setReport,
}) {
  const url = "/report/admin/report/" + id + "/";
  api.get(url).then((response) => {
    setSummary(response.data.stt_report_summary_stt_report);
    setProfile(response.data.stt_report_profile_stt_report);
    setReport(response.data);
    setLoaded(true);
  });
}

export function getReportSD(id, setList, setLoaded) {
  const url = "/report/admin/deposit/report_details/" + id + "/";
  api
    .get(url)
    .then((response) => {
      setList(response.data);
      setLoaded(true);
    })
    .catch((res) => {
      if (res.status === 404) {
        setList(null);
      }
    });
}

export function getSettlement(id, setList, setLoaded) {
  const url = "/report/admin/report/settlement_details/" + id + "/";
  api
    .get(url)
    .then((response) => {
      setList(response.data);
      setLoaded(true);
    })
    .catch((res) => {
      if (res.status === 404) {
        setList(null);
      }
    });
}

export function getDownloadReport(id, merchant_name, report_number, brand) {
  const url = `/report/admin/report/report_download/${id}/`;
  api
    .get(url, {
      responseType: "blob",
    })
    .then((response) => {
      fileDownload(
        response.data,
        `${merchant_name}_${report_number}_${brand}.xlsx`
      );
    });
}

export function setAdjustmentFee(props) {
  const url = `/report/admin/report/adjustment_fee/`;
  api
    .post(url, {
      ...props,
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg();
      } else {
        showErrorMsg(res?.data?.details);
      }
    })
    .catch((err) => showErrorMsg(err?.data?.details));
}

export function getReportPSNList(year, page, pageSize, callback) {
  const url = "/payout/report_psn/filter/";
  api
    .post(url, { year, page, page_size: pageSize })
    .then((response) => {
      callback && callback(response.data);
    })
    .catch((err) => {
      console.error(err);
      callback && callback(null);
    });
}

export function getDownloadReportPSN(id, file_name, callback) {
  const url = `/payout/report_psn/download_file/`;
  const payload = {
    pk: id,
  };
  api
    .post(url, payload, {
      responseType: "blob",
    })
    .then((response) => {
      if (response.status === 200 || response.status === 201) {
        fileDownload(response.data, file_name);
      } else {
        showErrorMsg(response.data.detail);
      }
    })
    .catch((err) => {
      console.error(err);
      showErrorMsg("Failed to download");
    })
    .finally(() => {
      callback && callback();
    });
}
